export default __webpack_public_path__ + "static/media/ic_wallet_white_16.b3d7531c.svg";